// src/features/tag/useTagUsage.ts

import { useQuery } from '@tanstack/react-query';
import { TagApi } from './TagApi';
import { TAG_QUERY_KEYS } from '@/lib/constants/tag';
import { useAuth } from '@/features/auth/hooks/useAuth';
import type { TagUsage } from '@/lib/types/Tag';

export interface UseTagUsageResult {
  usages: TagUsage[];
  isLoading: boolean;
  isError: boolean;
}

/**
 * Account tag vocabulary with usage counts (Manage Tags drawer).
 * Server returns rows sorted by label; short staleTime because counts go
 * stale with every media/tag edit.
 */
export function useTagUsage(options?: { enabled?: boolean }): UseTagUsageResult {
  const { selectedCId } = useAuth();

  const query = useQuery({
    queryKey: TAG_QUERY_KEYS.usage(selectedCId ?? 0),
    queryFn: async () => {
      const response = await TagApi.getTagUsage(selectedCId!);
      return response.tags;
    },
    enabled: selectedCId != null && (options?.enabled ?? true),
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
  });

  return {
    usages: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
